module.exports = __webpack_public_path__ + "img/car-2.c56fb2a8.png";